module.exports = __webpack_public_path__ + "c83ef64baac12d939fcc8497257c344b.png";